import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ENSGridResizeType, INSGridConfig } from '@norfolk-southern/accessns-components';
import { GridOptions } from 'ag-grid-community';

import { NSReservationsConstants } from '@ruby/configs/reservations.constants';
import { EReservationGridTitle, EReservationGridType } from '@ruby/shared/enums/reservations.enums';
import { IGridPrintTitle } from '@ruby/shared/models/commons/grid.interface';
import { IReservationDetails } from '@ruby/shared/models/reservations/reservations.interface';

@Component({
  selector: 'ng-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.scss']
})
export class ReservationsComponent implements OnChanges {
  @Input() loading!: boolean;
  @Input() reservations!: Array<IReservationDetails>;
  @Input() name!: EReservationGridType;
  @Input() title!: EReservationGridTitle;
  @Input() printTitle!: IGridPrintTitle;
  @Output() reload = new EventEmitter();
  gridOptions: GridOptions = NSReservationsConstants.gridOptions;
  resizeType = ENSGridResizeType.SIZECOLUMNSTOFIT;
  config: INSGridConfig = {};

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.printTitle && changes.printTitle.currentValue) {
      this.config = { headerDetails: changes.printTitle.currentValue };
    }
  }
}
